import { initContract } from '@ts-rest/core';
import { authOrderContract } from './order.auth.contract';

const c = initContract();

export const orderContract = c.router(
  {
    auth: authOrderContract,
  },
  {
    pathPrefix: '/order',
    strictStatusCodes: true,
  }
);

export * from './models';
export * from './order.auth.contract';

